import { TFestDetails } from "../constants";


export const dateStrForFestival = (details: TFestDetails) => {
    return `${details.startDate.format("DD MMM")} - ${details.endDate.format("DD MMM")}, ${details.year}`;
}
